//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { bindButtonClickEvent, ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import ShareView from "./share_view";
import SdkDefine from "../../../../sdk/collection/sdk_define";
import SdkManager from "../../../../manager/sdk_manager";
@ccclass
@moduleInit("Share")
export default class Share extends ModuleBase<ShareView, null> {

    shareContent
    shareCallback
    shareStatus = 0
    startShareTime = 0
    shareChannel
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/public/share";
        this.viewType = ShareView;
        this.needViewMask = true
        this.clickAnywhereClose = true
        this.needAnim = true
        this.needViewBaseBgMini = true
        this.needViewBaseTitleBg = true
        this.needViewBaseCloseBtn = true
    }
    onShow(intentData) {
        this.shareCallback = intentData.shareSuccessCallback
        this.shareContent = intentData.shareContent
        this.bindEvent();
        this.view.facebookDeal()
    }
    private bindEvent() {
        let self = this
        this.eventBind("game_event_show", function (show) {
            if (show) {
                self.onApplicationShow()
            } else {
                if (self.shareStatus == 1) {
                    self.startShareTime = new Date().getTime()
                    self.shareStatus = 2
                }
            }
        })

    }
    @bindButtonClickEvent("closeBtn")
    closeBtn() {
        this.hide()
    }
    @bindButtonClickEvent("btnShareLine")
    btnShareLine() {
        this.shareChannel = "Line"
        this.share(SdkDefine.LINE_NAME)
    }
    @bindButtonClickEvent("btnShareFacebook")
    btnShareFacebook() {
        this.shareChannel = "Facebook"
        this.share(SdkDefine.FACE_BOOK_NAME)
    }

    share(sdkname) {
        if (this.shareContent) {
            this.shareStatus = 1
            SdkManager.instance.req_share(sdkname, this.shareContent);
        }
    }
    onApplicationShow() {
        let now = new Date().getTime()
        let legitimate = false

        if (now - this.startShareTime > 3000 && now - this.startShareTime < 41000) {
            legitimate = true
        }
        cc.log(`===开始分享时间${this.startShareTime},回到游戏时间：${now},时间差：${now - this.startShareTime},legitimate : ${legitimate} ,shareStatus:${this.shareStatus} ===`)
        if (this.shareStatus == 2 && legitimate) {
            this.shareStatus = 0
            if (this.shareCallback) {
                this.shareCallback(this.shareChannel, "friend")
            }
        }
    }
}